// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3CS5b","addWidgetButton":"Header_addWidgetButton__2aEOt","dashboardTabs":"Header_dashboardTabs__2iRa6","active":"Header_active__10L27"};